import { useI18n as useVueI18n } from "vue-i18n";
import { getLanguage, setLanguage, languageOptions } from "~/i18n/index";

/**
 * Nuxt3 i18n composable（全端：依賴 plugins/i18n.js 掛載的 vue-i18n）
 * 在组件中使用：const { t, locale, setLocale } = useI18n()
 */
export function useI18n() {
	try {
		const { t, tm, locale } = useVueI18n();
		const trackTranslationDeps = () => {
			void locale.value;
		};
		const tHtml = key => {
			const message = tm(key);
			return typeof message === "string" ? message : key;
		};
		return {
			t,
			tm,
			tHtml,
			locale,
			setLocale: (lang, options) => {
				const result = setLanguage(lang, options);
				if (locale) {
					locale.value = lang;
				}
				return result ?? Promise.resolve();
			},
			getLanguage,
			languageOptions,
			trackTranslationDeps,
		};
	} catch {
		const trackTranslationDeps = () => {};
		return {
			t: key => key,
			tm: () => [],
			tHtml: key => key,
			locale: { value: "zh-TW" },
			setLocale: () => {},
			getLanguage: () => "zh-TW",
			languageOptions,
			trackTranslationDeps,
		};
	}
}
